import track1 from '../audio/A-Ha-Take-On-Me.mp3';
import track2 from '../audio/Wham-Last-Christmas.mp3';

export const bakgroundColors = ['rgba(31,24,65,0.9)', 'rgba(32,35,114,0.9)', 'rgba(202,161,169, 0.9)'];

export const data = [
  {
    id: 1,
    name: 'Take On Me',
    author: 'A-HA',
    originalAuthor: '',
    link: track1,
    text: `We're talking away
I don't know what
I'm to say I'll say it anyway
Today's another day to find you
Shying away
I'll be coming for your love, OK? \n
Take on me,
Тake me on
I'll be gone
In a day or two `,
    videoLink: 'https://www.youtube.com/watch?v=djV11Xbc914',
    cover: 'https://s30886.pcdn.co/wp-content/uploads/2018/11/6-3.jpg',
  },
  {
    id: 2,
    name: 'Last Christmas',
    author: 'Wham',
    originalAuthor: '',
    link: track2,
    text: '',
    videoLink: '#',
    cover: '#',
  },
  {
    id: 3,
    name: 'Test700KB',
    author: 'Test1',
    originalAuthor: 'Test2',
    link: 'https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_700KB.mp3',
    text: `https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3`,
    videoLink: '#',
    cover: '#',
  },
  {
    id: 4,
    name: 'Test1MG',
    author: 'Test2',
    originalAuthor: 'Test3',
    link: 'https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3',
    text: `https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_1MG.mp3`,
    videoLink: '#',
    cover: '#',
  },
  {
    id: 5,
    name: 'Test2MBTest2MBTest2MBTest2MBTest2MBTest2MBTest2MBTest2MBTest',
    author: 'Test3',
    originalAuthor: '',
    link: 'https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3',
    text: `https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3
https://file-examples-com.github.io/uploads/2017/11/file_example_MP3_2MG.mp3`,
    videoLink: '#',
    cover: '#',
  },
];

export const links = {
  author: 'https://praktikum.yandex.ru/',
  offer: 'https://api.kanye.rest',
  marshak: 'https://marshakbooks.ru/',
};

export const streamings = [
  {
    title: 'Яндекс.Музыка ↗',
    link: 'https://music.yandex.ru/home',
    id: '0',
  },
  {
    title: 'Spotify ↗',
    link: 'https://www.spotify.com/ru-ru/',
    id: '1',
  },
  {
    title: 'Apple Music ↗',
    link: 'https://www.apple.com/ru/apple-music/',
    id: '2',
  },
  {
    title: 'VK Music ↗',
    link: 'https://vk.com/vkmusic',
    id: '3',
  },
];
